import { Link } from "@tanstack/react-router";
import { ClipboardCheck, Settings, MonitorCog, Wrench, Paintbrush } from "lucide-react";
import { AnimatedSection, StaggerContainer, StaggerItem } from "@/components/AnimatedSection";

const picks = [
  { to: "/mot", icon: ClipboardCheck, label: "MOT Testing", desc: "Government-standard test" },
  { to: "/servicing", icon: Settings, label: "Servicing", desc: "Interim, full & major" },
  { to: "/diagnostics", icon: MonitorCog, label: "Diagnostics", desc: "Pinpoint the problem" },
  { to: "/mechanical-repairs", icon: Wrench, label: "Repairs", desc: "Brakes, clutch & more" },
  { to: "/bodywork", icon: Paintbrush, label: "Bodywork", desc: "Dents, paint & panels" },
] as const;

export function ServicePicker() {
  return (
    <AnimatedSection>
      <section className="py-14 md:py-18 bg-secondary">
        <div className="mx-auto max-w-5xl px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground text-center">What Do You Need?</h2>
          <StaggerContainer className="mt-8 grid grid-cols-2 sm:grid-cols-5 gap-3">
            {picks.map((p) => (
              <StaggerItem key={p.to}>
                <Link
                  to={p.to}
                  className="group flex flex-col items-center gap-2 rounded-xl border border-border bg-card p-5 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/8 group-hover:bg-primary/15 transition-colors">
                    <p.icon className="h-5.5 w-5.5 text-primary" />
                  </div>
                  <span className="text-sm font-bold text-foreground text-center">{p.label}</span>
                  <span className="text-[11px] text-muted-foreground text-center leading-tight hidden sm:block">{p.desc}</span>
                </Link>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </section>
    </AnimatedSection>
  );
}
